import Header from './header.vue'
import Content from './content.vue'
import Footer from './footer.vue'

export default {
  Header,
  Content,
  Footer
}
